export default "__VITE_ASSET__CbBUkUQT__"